<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-user-profile-form
        :user-email="$store.getters['account/email']"
        @notifChanged="onNotifChanged"
      />
    </div>
  </div>
</template>
<script>
import EditUserProfileForm from './UserProfile/EditUserProfileForm.vue';

export default {
  components: {
    EditUserProfileForm,
  },
  data: () => ({}),
  methods: {
    onNotifChanged(notifActivated) {
      if (notifActivated) {
        // If new value is true, we have to activate notifications for that user
        this.$http
          .post(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/usernotification/`,
            {
              email: this.$store.getters['account/email'],
            },
          )
          .then(response => {
            this.$notify({
              message: 'Les notifications ont été activées avec succés',
              icon: 'add_alert',
              type: 'success',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
            });
          })
          .catch(error => {
            this.$notify({
              message: `Echec de l'activation des notifications, veuillez réessayer ou contacter le support.`,
              icon: 'add_alert',
              type: 'danger',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
            });
          });
      } else {
        // If new value is false, we have to desactivate notifications for that user
        this.$http
          .delete(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/usernotification/${this.$store.getters['account/email']}`,
          )
          .then(response => {
            this.$notify({
              message: 'Les notifications ont été desactivées avec succés',
              icon: 'add_alert',
              type: 'success',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
            });
          })
          .catch(error => {
            this.$notify({
              message:
                'Echec de la désactivation des notifications, veuillez réessayer ou contacter le support.',
              icon: 'add_alert',
              type: 'danger',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
            });
          });
      }
    },
  },
};
</script>
<style></style>
